<template>
  <div>
    <v-card height="64px" width="100%"
      class="background ml-4 mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
      style="position:fixed; z-index:200; top:0; width: 98%; padding-top: 16px;">
      <v-card-title class="pl-0 ml-0">
        <p class="breadcrumb-text-unselected underline-on-hover cursor" @click="$router.push('/masters')">
          Masters
        </p>
        <v-icon class="breadcrumb-arrow-unselected" style="margin-top: 6px !important">mdi-chevron-right</v-icon>
        <v-menu offset-y class="menuZindex">
          <template v-slot:activator="{ on }">
            <span v-on="on" class="breadcrumb-text" style="margin-top: 2px">
              Grades
              <v-icon class="breadcrumb-arrow cursor" style="margin-top: 5px !important">mdi-chevron-down</v-icon>
            </span>
          </template>
          <MastersDropdownComponent />
        </v-menu>
        <!-- <p class="breadcrumb-text" style="margin-top: 2px">Grades</p>
        <v-icon class="breadcrumb-arrow" style="margin-top: 5px !important">mdi-chevron-down</v-icon> -->
      </v-card-title>
    <UserNavMenu/>
    </v-card>
    <div fluid class="pad px-8">
      <v-row>
        <v-col>

          <v-dialog max-width="887px" class="cdz" v-model="dialog" center>
            <v-form ref="form" lazy-validation>
              <v-card>
                <v-card-title class="gray-02 mb-8">{{ formbtn() }} Grade</v-card-title>
                <v-card-text class="px-6 pb-0">
                  <v-text-field outlined class=" rounded-xl" v-model="gradeName" label="Enter Grade Name*"
                    :rules="[v => !!v || 'Grade name is required']" required></v-text-field>
                  <v-row class="pb-0 pt-0">
                    <v-col class="pb-0 mb-0" cols="6">
                      <v-select label="Select Board*" :items="boardData" outlined v-model="boardName" item-text="name"
                        item-value="name" class="rounded-xl" :rules="[v => !!v || 'Board name is required']" required>
                      </v-select>
                    </v-col>
                    <v-col class="pb-0 mb-0" cols="6">
                      <v-autocomplete v-model="selectedSubject" clearable deletable-chips
                        label="Select or Search Subjects" outlined class="rounded-xl" small-chips
                        :search-input.sync="searchSubject" :items="subjectData" multiple item-text="name"
                        item-value="name">
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-actions class="px-6 pb-6">
                  <small>*All fields are mandatory</small>
                  <v-spacer></v-spacer>
                  <v-btn width="102px" height="48px" rounded outlined class="btn outline-btn pa-4"
                    @click="dialog = false">Cancel</v-btn>
                  <v-btn width="102px" height="48px" rounded @click="saveInputs" class="btn primary-btn pa-4" :loading="loading">{{
                    formbtn()
                  }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>

          <v-dialog v-model="filterDialog" class="cdz" max-width="570px">
            <v-card width="570px" height="100%" class="filterDialogClass">
              <v-row class="mt-4 mx-1">
                <v-col>
                  <div class="pl-0 mb-2 text-body1 font-weight-bold grey--text">Filter</div>
                </v-col>
                <v-col class="d-flex justify-end">
                  <div @click="clearFilter" class="clear-filter-btn">CLEAR FILTER </div>
                </v-col>
              </v-row>

              <v-tabs vertical>

                <div class="ml-3 mt-4 mr-4 filterLine">

                  <v-tab class="black--text justify-start" active-class="activeTab">
                    <span>Boards</span>
                    <span
                      v-if="selectedBoardFilter.length > 0" class="ml-1">({{ selectedBoardFilter.length
                      }})</span></v-tab>
                  <v-tab class="black--text justify-start" active-class="activeTab">
                    <span>Subjects</span>
                    <span
                      v-if="selectedSubjectFilter.length > 0" class="ml-1">({{ selectedSubjectFilter.length
                      }})</span></v-tab>

                </div>

                <v-tab-item>
                  <v-card flat class="school-filter">
                    <v-card-text>
                      <v-chip-group v-model="selectedBoardFilter" active-class="active-chip" column :multiple="true">
                        <v-chip v-for="(boardType, index) in boardData" :key="index" :value="boardType.name" elevated>
                          {{ boardType.name }}
                        </v-chip>
                      </v-chip-group>
                    </v-card-text>
                  </v-card>
                </v-tab-item>

                <v-tab-item>
                  <v-card flat class="school-filter">
                    <v-card-text>
                      <v-chip-group v-model="selectedSubjectFilter" active-class="active-chip" column :multiple="true">
                        <v-chip v-for="(subjectType, index) in subjectData" :key="index" :value="subjectType.name"
                          elevated>
                          {{ subjectType.name }}
                        </v-chip>
                      </v-chip-group>
                    </v-card-text>
                  </v-card>
                </v-tab-item>

              </v-tabs>
              <div class="filterDialogButton">
                <v-card-actions class="px-6 pb-6">
                  <v-spacer></v-spacer>
                  <v-btn rounded outlined class="btn outline-btn pa-4" @click="filterDialog = false">Cancel</v-btn>
                  <v-btn :disabled="selectedBoardFilter.length == 0 && selectedSubjectFilter.length == 0"
                    :loading="filterLoadingBtn" rounded class="btn primary-btn pa-4"
                    @click="filterGrade(selectedBoardFilter, selectedSubjectFilter), getFilterCount()">Apply</v-btn>
                </v-card-actions>
              </div>
            </v-card>
          </v-dialog>
          <!-- 
          <v-dialog v-model="filterDialog" max-width="400px">
            <v-card width="400px" height="100%">
              <v-card-text class="pa-6">
                <v-row>
                  <v-col>
                    <div class="pl-1 text-body1 font-weight-bold">FILTER</div>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col>
                    <div @click="clearFilter" class="text-body1 font-weight-bold black--text cursor">
                      CLEAR FILTER
                    </div>
                  </v-col>
                </v-row>
                <div>
                  <v-card height="450px" elevation="0" id="myScroll" class="pt-5 ,pb-5">
                    <v-row class="pl-1">
                      <v-col>
                        <div class="text-body1 font-weight-normal black--text pt-3">
                          Boards
                        </div>
                      </v-col>
                    </v-row>
                    <v-chip-group v-model="selectedBoardFilter" active-class="primary" column :multiple="true">
                      <v-chip v-for="(boardType, index) in boardData" :key="index" :value="boardType.name" elevated>
                        {{ boardType.name }}
                      </v-chip>
                    </v-chip-group>

                    <v-row class="pl-1">
                      <v-col>
                        <div class="text-body1 font-weight-normal black--text pt-3">
                          Subjects
                        </div>
                      </v-col>
                    </v-row>
                    <v-chip-group v-model="selectedSubjectFilter" active-class="primary" column :multiple="true">
                      <v-chip v-for="(subjectType, index) in subjectData" :key="index" :value="subjectType.name" elevated>
                        {{ subjectType.name }}
                      </v-chip>
                    </v-chip-group>

                  </v-card>
                  <div>
                    <v-card-actions class="px-6 pb-6">
                      <v-spacer></v-spacer>
                      <v-btn rounded outlined class="pa-4" @click="filterDialog = false">Cancel</v-btn>
                      <v-btn :disabled="selectedBoardFilter.length == 0 && selectedSubjectFilter.length == 0" :loading="filterLoadingBtn" rounded class="accent pa-4"
                        @click="filterGrade(selectedBoardFilter, selectedSubjectFilter)">Apply</v-btn>
                    </v-card-actions>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog> -->

        </v-col>
        <!-- <v-col cols="4">
        <v-text-field label="Search" prepend-inner-icon="mdi-magnify" v-model="search" clearable></v-text-field></v-col> -->
      </v-row>


      <v-row class="d-flex justify-center my-0 py-0">
        <v-col>
          <div class="text-h6">Grades</div>
        </v-col>



        <v-col cols="10" class="pl-0 ml-0">
          <v-row justify="end" class="mb-1 mt-0">
            <v-text-field solo label="Search here..." prepend-inner-icon="mdi-magnify" v-model="search" hide-details
              class="search-bar border-button rounded-pill mx-3" dense clearable></v-text-field>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="btn outline-btn elevation-0 mx-2 pl-4 pr-6"
                  :class="filterCount > 0 ? 'outline-disabled-btn' : ''"
                  rounded
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  :disabled="filterCount > 0"
                >
                <v-img
                v-bind="attrs" 
                v-on="on" 
                :style="filterCount > 0 ? 'filter: grayscale(100%) opacity(50%);' :''"
                :src="require(`@/assets/svg/sort.svg`)"
                />              
                  <span>SORT</span>
                </v-btn>
              </template>
              <v-list>
                <v-list-item 
                  v-for="option in sortOptions" 
                  :key="option.value" 
                  @click="selectSortOption(option.value)"
                  :class="{'selected-sort-option': selectedSort === option.value}"
                >
                  <v-list-item-title>
                    {{ option.label }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
              </v-menu>
              <v-btn depressed outlined rounded class="btn outline-btn mx-3" @click="filterDialog = true"><v-icon class="pr-2">mdi-tune</v-icon><span
                v-if="filterCount > 0">Filter ({{ filterCount }})</span>
              <span v-else>Filter</span></v-btn><v-btn class="btn mx-3" outlined
              rounded @click="deleteDialog = true"
              :class="selected.length > 0 ? 'outline-btn' : 'disabled-outline-btn'" v-if="$store.state.role.Grade.delete"
              :disabled="selected.length == 0"><v-icon class="pr-2">mdi-trash-can-outline</v-icon>Delete</v-btn>
            <v-btn depressed outlined rounded class="btn outline-btn mx-3" @click="downlaodRoles"><v-icon>mdi-import
                mdi-rotate-90</v-icon></v-btn>

            <v-btn @click="() => {
              dialog = true;
              formbtnBool = false;
              newCreateGradeValue();
            }
              " class="btn primary-btn mx-3" v-if="$store.state.role.Grade.create" depressed rounded><v-icon class="pr-2">mdi-plus</v-icon>Create</v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-data-table fixed-header height="calc(100vh - 230px)" class="rounded-table" v-model="selected"
        :loading="dataTableLoading" loading-text="Loading Grades" :headers="computedHeaders" :items="tableData" show-select
        :disable-sort="true"
        :items-per-page="options.itemsPerPage"
        :server-items-length="count"
        :options.sync="options"
        :single-select="singleSelect"
        hide-default-footer
         ref="myTable"
        :class=" isScrollable ? 'frozen-columns-table' : ''"
        >
        <template v-slot:loading>
          <bubble-loader/>
        </template>
        <template v-slot:no-results>
        <div class="custom-no-data">
          <p>No Data Available</p>
        </div>
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          {{ getDate(item.created_at) }}
        </template>
          <template v-slot:[`item.subjects`]="{ item }">
            <div class="my-custom-tooltip">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{ showItemsAndMoreLength(item.subjects.join()).displayValue }}
                  </span>
                </template>
                <span :class="item.subjects.length > 1 ? 'custom-tooltip': ''"  v-for="sub in item.subjects">{{ sub}}</span>
              </v-tooltip>
            </div>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon class="mr-2 pa-4" @click="updateData(item)">
            <img width="36px" height="36px" class="cursor" src="../../assets/edit.svg" />
          </v-btn>
        </template>
            <template v-slot:footer="{ props }">
              <table-footer
                :pagination="props.pagination"
                :options="props.options"
                @update-options="onFooterUpdate"
              />
            </template>
      </v-data-table>
      <v-dialog v-model="deleteDialog" class="cdz" max-width="366px" persistent>
        <v-card fluid>
          <v-container fluid class="pa-0">
            <v-card-text class="text-center">
              <v-container></v-container>
              <v-avatar color="background" size="90"><v-icon size="65">mdi-trash-can-outline</v-icon></v-avatar>

              <p class="text-h5 pt-6 pb-0">Delete Grade</p>
              <p class="text-disabled grey--text text-subtitle-1 pt-3" color="rgba(0, 0, 0, 0.6)" disabled>
                This action will permanently delete the item . This cannot be
                undone
              </p>

              <div class="d-flex justify-space-between pt-4 pb-2" fluid>
                <v-btn depressed class="background black--text" large width="157px" @click="deleteDialog = false"
                  rounded>CANCEL</v-btn>
                <v-btn class="accent white--text" depressed large width="157px" rounded :loading="dLoading"
                  @click="deleteData(selected)">DELETE</v-btn>
              </div>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="errorDialog" class="cdz" max-width="366px" persistent>
        <v-card>
          <v-container fluid class="pa-8">
            <v-card-text class="text-center d-flex flex-column align-center">
              <v-icon color="error" size="96">mdi-close-circle-outline</v-icon>
              <p class="text-h5 pt-2 font-weight-medium">Error</p>
              <p class="text-h6 py-3 font-weight-regular">{{ errorMessage }}</p>
              <v-btn class="btn primary-btn" large width="157px" rounded @click="errorDialog = false">Ok</v-btn>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteSuccessDialog" class="cdz" max-width="366px" persistent>
        <v-card>
          <v-container fluid class="pa-8">
            <v-card-text class="text-center d-flex flex-column align-center">
              <v-icon color="#228B22" size="96">mdi-check-circle-outline</v-icon>
              <p class="text-h5 font-weight-bold py-4">Grade Deleted</p>
              <v-btn class="btn primary-btn" large width="157px" rounded @click="deleteSuccessDialog = false">Ok</v-btn>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="successDialog" class="cdz" max-width="366px" persistent>
        <v-card>
          <v-container fluid class="pa-8">
            <v-card-text class="text-center d-flex flex-column align-center">
              <v-icon color="success" size="96">mdi-check-circle-outline</v-icon>
              <p class="text-h5 py-4"> {{ formbtnBool == false ? 'Created' : 'Updated' }} successfully</p>
              <v-btn class="btn primary-btn" large width="157px" rounded @click="successDialog = false">Ok</v-btn>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>
    </div>

    <!-- Notification Dialog -->
    <v-dialog v-model="notificationDialog" class="cdz" max-width="380px">
      <Notification @close-dialog="notificationDialog = false" />
    </v-dialog>

  </div>
</template>
<script>
import GradeController from "@/controllers/GradeController";
import BoardController from "@/controllers/BoardController";
import SubjectController from "@/controllers/SubjectController";
import AuthService from "../../services/AuthService";
import Papa from "papaparse";
import Notification from "../Notification.vue";
import MastersDropdownComponent from "../../components/MastersDropdownComponent.vue"
import BubbleLoader from "@/components/BubbleLoader.vue";
import UserNavMenu from "@/components/UserNavMenu.vue";
import isTableScrollableMixin from "@/mixins/isTableScrollableMixin";
import { debounce } from "lodash";

export default {
  name: "GradesView",
  mixins: [  isTableScrollableMixin ],
  components: {
    Notification, MastersDropdownComponent, BubbleLoader,UserNavMenu
  },

  data() {
    return {
      notificationDialog: false,
      appliedFilter: false,
      debouncedGetGrades: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      pageSize: 10,
      page: 1,
      count: 0,
      errorDialog: false,
      successDialog: false,
      deleteSuccessDialog: false,
      errorMessage: "",
      dialog: false,
      dialogTitle: "Dialog Title",
      input1: "",
      input2: "",
      editId: null,
      gradeName: null,
      boardName: "",
      boardData: [],
      subjects: [],
      singleSelect: false,
      dLoading: false,
      dataTableLoading: true,
      gradeData: null,
      formbtnBool: false,
      deleteDialog: false,
      selectedSubject: [],
      searchSubject: [],
      subjectData: [],
      selectedSubjectFilter: [],
      selectedBoardFilter: [],
      filterLoadingBtn: false,
      filterDialog: false,
      filterCount: 0,
      filterData: false,
      loading: false,
      selected: [],
      search: '',
      searchBool: false,
      sortCol:"name",
      sortOrder: "asc", // Default sort order (asc or desc)
      selectedSort: "gradeAsc", // Default selected sort option
      sortOptions: [
        { value: "gradeAsc", label: "Grade - Ascending (A-Z)" },
        { value: "gradeDesc", label: "Grade - Descending (Z-A)" },
        { value: "dateNewest", label: "Date - Newest" },
        { value: "dateOldest", label: "Date - Oldest" },
      ],
      headers: [
        { text: "Grade Name", value: "name", cellClass: "w-15" },
        { text: "Board Name", value: "board", cellClass: "w-15" },
        { text: "Subjects", value: "subjects", cellClass: "w-35" },
        // { text: "Created On", value: "created_at" },
        { text: "Actions", value: "actions" },
      ],
      tableData: [],
      rules: {
        required: (value) => !!value || "Field is required",
      },
    };
  },
  watch: {
    // Add watcher for search
    search(newValue) {
      // Update URL when search changes
      this.$router.replace({ 
        query: { 
          ...this.$route.query,
          search: newValue || undefined 
        }
      }).catch(() => {});
      this.search = newValue || "";
      this.options.page = 1
      this.debouncedGetGrades();
    }
  },
  methods: {
    async onFooterUpdate(newOptions) {
      this.options = { ...this.options, ...newOptions };
      await this.$nextTick();
      await this.getGrades();
    },
      showItemsAndMoreLength(data) {
    let stringToArray = data.split(',').filter(item => item.trim() !== '');
    const itemsToShow = 3;
    let displayedItems = stringToArray.slice(0, itemsToShow);
    let baseString = displayedItems.join(', ');
    const maxLength = 60;
    let firstVal = baseString.length > maxLength ? `${baseString.slice(0, maxLength)}...` : baseString;
    let remainingCount = stringToArray.length - itemsToShow;
    let secondval = remainingCount > 0 ? `, +${remainingCount}` : '';  
    return { 
      displayValue: firstVal + secondval, 
      tooltipValue: data 
    };
  },
    logout() {
      AuthService.logout();
      this.$router.push("/login");
    },

    async downloadCSV(csvData, fileName) {

      const csv = Papa.unparse(csvData);


      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

      if (navigator.msSaveBlob) {

        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {

          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },

    async downlaodRoles() {
      const fileName = 'grades.csv';
      const response = await GradeController.getAllGrades()
      const grades = response.data.grades;
      this.downloadCSV(grades, fileName);
    },
    // async searchData(search){
    //   const response = await GradeController.searchGrade(
    //     this.pageSize,
    //     this.page,
    //     search,
    //   );
    //   console.log(response.data);
    //   console.log(this.searchBool);
    //   this.count = response.data.data.count;
    //   this.tableData = response.data.data.rows;
    // },
    getDate(timeStamp) {
      return this.formatDate(timeStamp);
    },
    updateData(item) {
      this.editId = item.id; // selected id for edit
      this.formbtnBool = true; // change update/create btn value
      this.dialog = true;
      this.gradeName = item.name;
      this.boardName = item.board;
      this.selectedSubject = item.subjects;

    },
    async newCreateGradeValue() {
      this.gradeName = null;
      this.boardName = null;
      this.selectedSubject = [];
    },

    formbtn() {
      return this.formbtnBool === false ? "Create" : "Update";
    },

    async saveInputs() {
      if (this.$refs.form.validate()) {
        var res;
        this.loading = true;
        // checking case for update/create
        if (this.formbtnBool == false) {
          const response = await GradeController.createGrade({
            name: this.gradeName,
            board: this.boardName,
            subjects: this.selectedSubject,
          });
          res = response;
          this.loading = false;
          console.log(response);
        } else {
          const response = await GradeController.updateGrade(
            {
              name: this.gradeName,
              board: this.boardName,
              subjects: this.selectedSubject,
            },
            this.editId
          );
          res = response
          console.log(response);
          this.loading = false;
        }
        // Close the dialog
        if (res.data.flag) {
          this.successDialog = true;
        } else {
          this.errorDialog = true;
          this.errorMessage = res.data.error;
        }
        this.formbtnBool == false;
        this.dialog = false;
        this.getGrades();
      }
    },

    async deleteData(data) {
      // if(data.length==1){
      //   // if block for delete single data
      // this.dLoading = true;
      // this.deleteDialog = true;
      // const response = await GradeController.deleteGrade(data[0].id);
      //   // checking condition for response status
      //         if (response.data.success) {
      //           this.getGrades();
      //         this.deleteDialog = false;
      //         console.log(response);
      //         this.dLoading = false;
      //         this.selected = []
      //         }
      //         else {
      //           alert(response.data.error)
      //         } 
      // }
      // // else bloak for bulk delete data
      // else{
      //   var ids="";
      //   for(var i=0;i<data.length;i++){
      //     ids = ids + data[i].id;
      //       if( i != data.length - 1 ) {
      //           ids = ids + ","
      //       }
      //   }
      var ids = [];
      data.forEach((dataDelete) => {
        ids.push(dataDelete.id)
      })
      this.dLoading = true;
      const response = await GradeController.deleteBulkGrade(ids);
      // checking condition for update response status      
      if (response.data.flag) {
        this.getGrades();
        this.deleteDialog = false;
        console.log(response);
        this.dLoading = false;
        this.selected = []
      }
      else {
        this.getGrades();
        this.deleteDialog = false;
        console.log(response);
        this.dLoading = false;
        this.selected = []
        alert(response.data.error)
      }
      this.deleteDialog = false;
      this.dLoading = false;
      this.deleteSuccessDialog = true;
    },

    async getGrades() {
      this.page = this.options.page;
      this.pageSize = this.options.itemsPerPage;
      const params = {
        page: this.options.page,
        pageSize: this.options.itemsPerPage,
        search: this.search,
        sortCol: this.sortCol,
        sortOrder: this.sortOrder,
        boards: this.selectedBoardFilter.join(','),
        subjects: this.selectedSubjectFilter.join(',')
      }
      const query = "?"+(new URLSearchParams(params).toString());
      const response = await GradeController.getAllGradesByPagination(
          query    
    );
      if (response.status == 200) {
        this.dataTableLoading = false;
        console.log("", response);
        this.count = response.data.count;
        if (response.data.grades.length > 0) {
          this.tableData = response.data.grades;
        }
        this.getBoards();
        this.getSubjects();
      }
      else {
        this.dataTableLoading = false;
        // alert(response.data.error)
        alert("Something went wrong");

      }


    },
    async getBoards() {
      const response = await BoardController.getBoards();
      if (response.status) {
        if (response.data.boards.length > 0) {
          this.boardData = response.data.boards;
        }

      }
      else {
        alert(response.data.error)
      }
    },
    async getSubjects() {
      const response = await SubjectController.getSubject();
      if (response.status == 200) {
        if (response.data.subjects.length > 0) {
          this.subjectData = response.data.subjects;
        }
      }
      else {
        alert(response.data.error)
      }
    },
    sortByAlphabet(array, key) {
      array.sort(function (a, b) {
        var nameA = a[key].toUpperCase(); // Convert to uppercase to ensure case-insensitive sorting
        var nameB = b[key].toUpperCase();

        if (nameA < nameB) {
          return -1;
        }

        if (nameA > nameB) {
          return 1;
        }

        return 0;
      });
      return array;
    },
    clearFilter() {
      this.appliedFilter = false;
      this.selectedBoardFilter = [];
      this.selectedSubjectFilter = [];
      this.filterDialog = false;
      this.selectedSort = "gradeAsc";
      this.sortCol = "name";
      this.sortOrder = "asc";
      this.getGrades();
      this.filterData = false;
      this.filterCount = 0;

    },
    async filterGrade(selectBoards, selectSubject) {
      console.log("filter function call");
      this.selectedSort = "gradeAsc";
      this.sortCol = "name";
      this.sortOrder = "asc";
      this.filterLoadingBtn = true;
      await this.getGrades();
      this.filterLoadingBtn = false;
      this.filterData = true;
      this.appliedFilter = true;
      this.filterDialog = false;
    },

    getFilterCount() {
      this.filterCount = 0;
      if (this.selectedBoardFilter.length > 0) {
        this.filterCount++;
      }
      if (this.selectedSubjectFilter.length > 0) {
        this.filterCount++;
      }
    },
    selectSortOption(sortOption) {
      this.selectedSort = sortOption;
      switch (sortOption) {
        case "gradeAsc":
          this.sortCol = "name";
          this.sortOrder = "asc";
          break;
        case "gradeDesc":
          this.sortCol = "name";
          this.sortOrder = "desc";
          break;
        case "dateNewest":
          this.sortCol = "createdOn";
          this.sortOrder = "desc";
          break;
        case "dateOldest":
          this.sortCol = "createdOn";
          this.sortOrder = "asc";
          break;
        default:
          this.selectedSort = "gradeAsc";
          this.sortCol = "name";
          this.sortOrder = "asc";
      }
      this.options.page = 1;
      this.getGrades();
    },
 

  },
  created() {
    this.debouncedGetGrades = debounce(this.getGrades, 500);
    // Get search from URL if it exists
    const urlSearch = this.$route.query.search;
    if (urlSearch) {
      this.search = urlSearch;
    }
    this.getGrades();
    this.$store.state.breadcrumb = "Grades";
  },
   computed: {
    computedHeaders() {
      return this.headers.filter((h) => {
        if (h.value === 'actions' && !this.$store.state.role.Grade.update) return false;
        return true;
      })
    }
  }
};
</script>
